import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import { fetchPendingArrangements } from 'actions/purchases';
import { getPendingArrangement, getPageCount } from 'reducers';

const withPendingArrangements = (DecoratedComponent) => {
  class WithPendingArrangements extends Component {
    componentDidMount() {
      this.fetchPendingArrangements();
    }

    componentDidUpdate(prevProps, prevState) {
      if (
        prevProps.page !== this.props.page ||
        prevProps.type !== this.props.type
      ) {
        this.fetchPendingArrangements();
      }
    }

    fetchPendingArrangements() {
      const { fetchPendingArrangements, page, type } = this.props;
      const status =
        type === 'all'
          ? ['pending_arrangement', 'arranged', 'denied_arrangement']
          : type;

      fetchPendingArrangements(page, { status });
    }

    render() {
      const { children, ...props } = this.props;
      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const { page = 1, type = 'pending_arrangement' } = qs.parse(search, {
      ignoreQueryPrefix: true,
    });
    const pendingArrangements = getPendingArrangement(state, page);

    return {
      pendingArrangements,
      pageCount: getPageCount(state, 'purchases', 'pendingArrangements', page),
      page,
      type,
    };
  };

  const mapDispatchToProps = {
    fetchPendingArrangements,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithPendingArrangements);
};

export default withPendingArrangements;
